<template>
	<div v-loading="loading">
		<slot name="alert"></slot>
		<el-form :model="form" ref="formRef" v-bind="$attrs" v-if="mode === 'DESIGN'">
			<template v-for="item in list" :key="item">
				<el-form-item :label="item.label" :prop="item.prop"
					:style="item.col ? 'width:' + item.col : item.width ? 'width:' + item.width : ''"
					v-if="item.isShow == false ? item.isShow : true">
					<slot :name="item.prop" :prop="item" :model="form[item.prop]">
						<el-input v-model="form[item.prop]" v-if="item.type === 'input'"
							:placeholder="item.placeholder ? item.placeholder : '请输入'" :style="item.style"
							:disabled="item.disabled" clearable>
							<template #append v-if="item.append">
								{{ item.append }}
							</template>
						</el-input>
						<el-input v-model="form[item.prop]" v-if="item.type === 'password'" type="password"
							:placeholder="item.placeholder ? item.placeholder : '请输入'" :style="item.style"
							:disabled="item.disabled" clearable>
							<template #append v-if="item.append">
								{{ item.append }}
							</template>
						</el-input>
						<el-select v-model="form[item.prop]" v-if="item.type === 'select'"
							:placeholder="item.placeholder ? item.placeholder : '请选择'" :multiple="item['multiple']"
							:filterable="item['filterable']" :reserve-keyword="item['reserveKeyword']"
							:style="item.style" clearable @change="selectChange($event, item)">
							<el-option :label="item.labelO ? itemO[item.labelO] : itemO.label"
								:value="item.valueO ? itemO[item.valueO] : itemO.value" v-for="itemO in item.options"
								:key="item.valueO ? itemO[item.valueO] : itemO.value" />
						</el-select>
						<el-select-v2 v-if="item.type === 'selectV2'" v-model="form[item.prop]" :options="item.options"
							:placeholder="item.placeholder ? item.placeholder : '请选择'" :style="item.style"
							:multiple="item['multiple']" :filterable="item['filterable']" :props="item.props" />
						<el-date-picker :style="{ width: item.width }" v-model="form[item.prop]" :type="item.types"
							v-if="item.type === 'datetimerange'" :value-format="item.formatValue"
							:format="item.formatLabel" :start-placeholder="item.startPlaceholder"
							:end-placeholder="item.endPlaceholder"
							:placeholder="item.placeholder ? item.placeholder : ''" clearable />
						<el-radio-group v-model="form[item.prop]" v-if="item.type === 'radio'" :style="item.style"
							:disabled="item.disabled" @change="changeRadio($event, item)">
							<el-radio :label="item.label" :value="item.value" v-for="item in item.options"
								:key="item.value">{{ item.label }}
							</el-radio>
						</el-radio-group>
						<el-cascader class="cascader" :style="{ width: item.width }" :options="item.options"
							:props="item.props" v-model="form[item.prop]" :filterable="item['filterable']"
							@change="changeCasader(item)" :before-filter="beforeFilter" :filter-method="filter"
							ref="cascader" :placeholder="item.placeholder ? item.placeholder : '请输入'"
							v-if="item.type === 'cascader'" />
						<el-input v-model="form[item.prop]" type="textarea" v-if="item.type === 'textarea'"
							:placeholder="item.placeholder ? item.placeholder : '请输入'" :style="item.style"
							:rows="item.row" clearable />
						<chooseImg v-if="item.type === 'image'" v-model="form[item.prop]"> </chooseImg>
						<chooseMoreImg v-if="item.type === 'imageMore'" v-model="form[item.prop]">
						</chooseMoreImg>
					</slot>
				</el-form-item>
			</template>
		</el-form>
		<slot name="footer"></slot>
	</div>
</template>

<script setup>
import { ref, onMounted, onUnmounted, nextTick } from 'vue'
import chooseImg from '../proDialog/chooseImg'
import chooseMoreImg from '../proDialog/chooseMoreImg'
const props = defineProps({
	/**
	 * 是否加载数据。修改、查看详情时 需要加载数据
	 */
	loading: {
		type: Boolean,
		default: false
	},
	list: {
		type: Array,
		default: []
	},
	form: {
		type: Object,
		default: {}
	},
	saving: {
		type: Boolean,
		default: false
	},
	mode: {
		type: String,
		default: 'DESIGN'
	}
})
const emit = defineEmits(['submit', 'selectChange', 'casaderChange', 'changeRadio'])
const cascader = ref()
const changeRadio = (e, item) => {
	emit('changeRadio', item, e)
}
const selectChange = (event, item) => {
	emit('selectChange', event, item)
}
const formRef = ref()

defineExpose({
	formRef
})
const changeCasader = (item) => {
	emit('casaderChange', item, cascader.value[0].getCheckedNodes()[0])
}
const beforeFilter = (value) => {
	return true
}
const filter = (node, keyword) => {
	return true
}
// // 没搜索词时展示完整的原列表数据
// const clear = () => {
// 	data.keyWord = ''
// 	data.options2 = JSON.parse(JSON.stringify(data.options2Copy))
// }
onMounted(() => { })

onUnmounted(() => { })
</script>

<style scoped>
:deep(.el-form--inline .el-form-item) {
	margin-right: 0px !important;
}
</style>
